import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { trackVisit } from "./lib/tracking";
import Landing from "./pages/Landing";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import Verify from "./pages/Verify";
import Onboarding from "./pages/Onboarding";
import Chat from "./pages/Chat";
import Profile from "./pages/Profile";
import Billing from "./pages/Billing";
import Admin from "./pages/Admin";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Impact from "./pages/Impact";
import TryZaf from "./pages/TryZaf";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500 font-body">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function GateOnboarding({ children }) {
  const { user } = useAuth();
  if (user && !user.onboarded && window.location.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
}

function App() {
  useEffect(() => {
    trackVisit();
  }, []);
  return (
    <div className="App font-body">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors closeButton />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/impact" element={<Impact />} />
            <Route path="/try" element={<TryZaf />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
            <Route path="/chat" element={<Protected><GateOnboarding><Chat /></GateOnboarding></Protected>} />
            <Route path="/profile" element={<Protected><GateOnboarding><Profile /></GateOnboarding></Protected>} />
            <Route path="/billing" element={<Protected><GateOnboarding><Billing /></GateOnboarding></Protected>} />
            <Route path="/admin" element={<Protected><Admin /></Protected>} />
            <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
            <Route path="/payment/cancel" element={<Protected><PaymentCancel /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
